const getParentDomain = (hostname: string) =>
  hostname.split('.').slice(1).join('.');

export const parentDomain = getParentDomain(window.location.hostname);
